import { AddDisciplineGroupDTO, DisciplineGroupApi, DisciplineGroupDTO, EditDisciplineGroupDTO, SemesterTypeEnum, StudyCycleEnum, StudyYearEnum, SubjectRequestType } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new DisciplineGroupApi(getAuthConfiguration());

export const getDisciplineGroup = (id: string) => {
    if (!id) {
        return {} as DisciplineGroupDTO;
    }
    return ApiFactory().apiDisciplineGroupGetDisciplineGroupByIdIdGet({ id });
}

export const getDisciplineGroups = (studyPlanId: string, namePattern?: string, semester?: SemesterTypeEnum, studyYear?: StudyYearEnum, page: number = 1, pageSize: number = 10) => {
    return ApiFactory().apiDisciplineGroupGetAllDisciplineGroupsGet({ page, pageSize, namePattern, semester, studyYear, studyPlanId });
}

export const getSubjectsForGroup = (semester: SemesterTypeEnum, studyYear: StudyYearEnum, planId: string, subjectRequestType: SubjectRequestType, subGroupId?: string, groupId?: string) => {
    return ApiFactory().apiDisciplineGroupGetAllSubjectsForGroupsGet({ semester, studyYear, groupId, planId, subGroupId, subjectRequestType });
}

export const assignSubjectsToGroup = (id: string, disciplines: string[]) => {
    return ApiFactory().apiDisciplineGroupAssignDisciplineToGroupIdPut({ id, requestBody: disciplines });
}

export const addDisciplineGroup = (addDisciplineGroupDTO: AddDisciplineGroupDTO) => {
    return ApiFactory().apiDisciplineGroupAddDisciplineGroupPost({ addDisciplineGroupDTO });
}

export const updateDisciplineGroup = (id: string, editDisciplineGroupDTO: EditDisciplineGroupDTO) => { 
    return ApiFactory().apiDisciplineGroupUpdateDisciplineGroupIdPut({ id, editDisciplineGroupDTO });
}

export const deleteDisciplineGroup = (id: string) => {
    return ApiFactory().apiDisciplineGroupDeleteIdDelete({ id });
}
